import { useLocalization } from "@fluent/react";
import styles from "./VinDetailsPrompt.module.css";

interface VinDetailsPromptProps {
  /** After a successful VIN decode, the fields below hold prefilled details to review. */
  showReview: boolean;
}

/**
 * The header line for the vehicle detail fields when VIN collection is on:
 * "No VIN? Enter car details below." by default, switching to
 * "Review details below." once a decode has prefilled the fields.
 *
 * Rendered by the page directly above the fields it introduces.
 */
function VinDetailsPrompt({ showReview }: VinDetailsPromptProps) {
  const { l10n } = useLocalization();

  return (
    <div className="margin--bottom--m">
      {showReview ? (
        <span className={styles.title}>
          {l10n.getString("auto-loan-auto-details-review-details", null, "Review details below.")}
        </span>
      ) : (
        <>
          <span className={styles.title}>
            {l10n.getString("auto-loan-auto-details-no-vin-title", null, "No VIN?")}
          </span>{" "}
          {l10n.getString(
            "auto-loan-auto-details-no-vin-subtitle",
            null,
            "Enter car details below."
          )}
        </>
      )}
    </div>
  );
}

export { VinDetailsPrompt };
